import { TpvEntityFocus } from '@app/domain/models/tpv/tpv-entity-focus.model';

/**
 * Dónde vive el foco TPV elegido en `/products` (feature 152). Lo escribe la
 * pantalla de productos y lo leen el dashboard y las migas de TPV: este puerto
 * es lo ÚNICO que comparten (ninguna importa a la otra).
 *
 * `focus()` es una lectura barata y, en la implementación de la app, reactiva
 * (una `signal`): leerla dentro de un `computed` sigue sus cambios.
 */
export abstract class TpvEntityFocusStore {
  abstract focus(): TpvEntityFocus | null;
  abstract set(focus: TpvEntityFocus): void;
  abstract clear(): void;
}
